import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { getKeyMetric, getShortNameForMetric } from './cell-semi-annually';
interface CellQuarterlyProps {
  quarterly: string;
  isTotal?: boolean;
  className?: string;
  metrics: Partial<MetricValues>;
  activeMetrics: string[];
}
function CellQuarterly(t0) {
  const $ = _c(23);
  const {
    metrics,
    quarterly,
    isTotal: t1,
    className,
    activeMetrics
  } = t0;
  const isTotal = t1 === undefined ? false : t1;
  const t2 = isTotal ? "bg-muted w-[105px] px-0" : "w-24 px-1";
  const t3 = !isTotal && "after:border-border relative after:absolute after:top-0 after:right-0 after:h-12 after:border-r after:content-[\"\"]";
  const t4 = isTotal && "lg:w-36 lg:min-w-[144px] lg:px-1";
  const t5 = isTotal && "xl:w-40 xl:min-w-[162px] xl:px-0.5";
  const t6 = isTotal && "2xl:min-w-[197px]";
  const t7 = isTotal && "3xl:min-w-[285px]";
  let t8;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = cn("flex flex-1 flex-row items-center justify-center py-4", t2, t3, "lg:w-[100px] lg:min-w-[100px] lg:px-1", t4, "xl:w-[190px] xl:min-w-[190px] xl:px-0", t5, "2xl:min-w-[191px] 2xl:px-0", t6, "3xl:min-w-[284px]", t7, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== quarterly) {
    t9 = <div className="text-foreground mb-2 text-center text-base leading-normal font-bold lg:text-xl lg:font-semibold lg:tracking-[0.4px]">{quarterly}</div>;
    $[8] = quarterly;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== activeMetrics || $[11] !== metrics) {
    let t11;
    if ($[13] !== metrics) {
      t11 = (metric, index) => <div key={index} className="3xl:min-w-20 flex min-w-[77.5px] flex-col xl:min-w-[83.5px] 2xl:min-w-[93.5px]"><div className="text-muted-foreground mb-1 text-center text-xs leading-normal font-medium lg:font-normal">{getShortNameForMetric(metric)}</div><div className="text-foreground text-center text-xs leading-normal font-semibold">{usLocalizedNumber(metrics[getKeyMetric(metric) as keyof MetricValues] ?? 0)}</div></div>;
      $[13] = metrics;
      $[14] = t11;
    } else {
      t11 = $[14];
    }
    t10 = activeMetrics.map(t11);
    $[10] = activeMetrics;
    $[11] = metrics;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <div className="flex flex-col lg:w-full lg:flex-row lg:justify-center">{t10}</div>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t9) {
    t12 = <div className="flex flex-1 flex-col items-center">{t9}{t11}</div>;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[20] = t12;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
export { CellQuarterly };